module.exports = __webpack_public_path__ + "img/icon-Turbo.f5e29078.png";